
import moment from 'moment';
import CryptoJS from "crypto-js";


export const truncateText = (text, wordLimit) => {
  if (!text) return 'N/A';
  const words = text.split(' ');
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...';
  }
  return text;
};

export const formatAndTruncateText = (text, wordLimit) => {
  if (!text) return 'N/A';

  // Add space after commas if not already present
  const cleanedText = text.replace(/,\s*/g, ', ');

  const words = cleanedText.split(' ');
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...';
  }
  return cleanedText;
};





export const getTheDays = (date) => {
  const createdDate = moment(date);
  const now = moment();

  if (createdDate.isSame(now, 'day')) {
    return 'Today';
  }
  if (createdDate.isSame(moment().subtract(1, 'day'), 'day')) {  // Checking if it's yesterday
    return 'Yesterday';
  }
  if (createdDate.isBefore(now, 'day')) {
    const diffInDays = moment().diff(createdDate, 'days');
    if (diffInDays == 1) {
      return `${diffInDays} day ago`;
    } else {
      return `${diffInDays} days ago`;
    }
  }
  return createdDate.fromNow();  // This returns a relative time like "a month ago"
};



export const maskEmail = (email) => {
  const [name, domain] = email.split("@");
  const maskedName = name[0] + "*".repeat(name.length - 1);
  const domainParts = domain.split(".");
  const maskedDomain =
    "*".repeat(domainParts[0].length) + "." + domainParts[1];

  return `${maskedName}@${maskedDomain}`;
};



export const maskPhoneNumber = (number) => {
  // Ensure the number is a string
  const numberStr = number.toString();

  // Extract the country code and the rest of the number
  const countryCode = numberStr.slice(0, 2);
  const maskedNumber = numberStr
    .slice(2) // Take the rest of the number
    .replace(/(\d{4})(\d{3})(\d{3})/, "**** *** ***");

  return `+${countryCode} ${maskedNumber}`;
};


export const filterTheArray = (address) => {
  if (!address) {
    return null; // Return null or any default value you prefer
  }
  const data = address;
  return data.split(",").at(-1); // Extract and return the last element
};


// Function to compare openingHours
export const isOpeningHoursEqual = (propsDataOpeningHours) => {
  // Create a reference array to compare against
  const referenceOpeningHours = Array(7).fill({ from: "", to: "", is24HourAvailable: false });

  // Check if the length matches
  if (propsDataOpeningHours.length !== referenceOpeningHours.length) {
    return false;
  }

  // Deep compare each object in the array
  return propsDataOpeningHours.every(
    (item, index) =>
      item.from === referenceOpeningHours[index].from &&
      item.to === referenceOpeningHours[index].to &&
      item.is24HourAvailable === referenceOpeningHours[index].is24HourAvailable
  );
};



// export const getQueryParams = (search) => {
//   const params = new URLSearchParams(search);
//   const queryObject = {};
//   for (const [key, value] of params.entries()) {
//     queryObject[key] = value;
//   }
//   return queryObject;
// };




export const getQueryParams = (search) => {
  const params = new URLSearchParams(search);
  const queryObject = {
    userId: "",
    activeKey: "",
    leadId: "",
    range: "",
    Category: "",
    customerId:"",
    paymentType:"",
    endDate:"",
    startDate:"",
     id:"",
     createdAt:"",
     subscriptionType :"",
     verificationStatus:"",
     leadCount:"",
     vendorId:"",
     status:"",
     referId:""
  };
  for (const [key, value] of params.entries()) {
    queryObject[key] = value ?? ""; // Ensures empty string for missing values
  }
  return queryObject;
};





// Hook for encryption
export const useEncrypt = () => {
  // Fetch the secret key from environment variables
  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const encrypt = (data) => {
    try {
      // Encrypt the data using the secret key
      return CryptoJS.AES.encrypt(data, secretKey).toString();
    } catch (error) {
      console.error("Encryption error:", error);
      return null;
    }
  };

  return { encrypt };
};

// Hook for decryption
export const useDecrypt = () => {
  // Fetch the secret key from environment variables
  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const decrypt = (encryptedData) => {
    try {
      // Decrypt the encrypted data using the secret key
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Decryption error:", error);
      return null;
    }
  };

  return { decrypt };
};


 export function capitalizeWords(input) {
  return input
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}